/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import lottie from 'lottie-web';
import dayjs from 'dayjs';
import {
  Space,
  Popover,
  Tooltip,
  Drawer,
  Typography,
  Row,
  Col,
  Descriptions,
  Modal,
  Form,
  Button,
  Input,
  Upload,
  Tag,
  message,
  Card
} from 'antd';
import Joyride, { STATUS, ACTIONS, EVENTS } from 'react-joyride';
import { updatePlanModal, updateNavigationTourGuide } from 'store/user';
import {
  DownOutlined,
  InfoCircleOutlined,
  FilePdfOutlined,
  CheckOutlined
} from '@ant-design/icons';
import EbzTable from 'components/EbzTable';
import EbzButton from 'components/EbzButton';
import EbzFilterGroup from 'components/EbzFilterGroup';
import EbzInputNumber from 'components/EbzInputNumber';
import Alert from 'components/Alert';
import reportsAPI from 'services/reports';
import merchantAPI from 'services/merchants';
import currencyFormat from 'utils/currencyFormat';
import { CloseIcon, CopyIcon, ExportIcon } from 'utils/icons';
import searchJson from 'assets/animation/search_empty.json';
import { payoutStatus } from 'constants';
import { GST_STATUS, INVOICE_ON_HOLD_REASON_DICT, PAYOUT_REPORT_STATUS } from 'constants/status';
import PayoutReportBlur from 'assets/images/payoutreport_table.webp';
import joyrideCustomTooltip from 'components/JoyrideComponent/JoyrideTooltip';
import EVENT_NAME from 'utils/const';
import trackingService from 'services/trackingService';
import BulkInvoiceModal from './BulkInvoiceModal';
import {
  getBulkInvoiceColumn,
  getPayoutReportColumn,
  PARTNER_INVOICE_PENDING,
  TOUR_PAYOUT_REPORT_CONTENT,
  PARTNER_INVOICE_ON_HOLD
} from './const';
import './PayoutReportsListPage.scss';

const { Meta } = Card;
const FormWrapper = styled(Form)`
  .ant-form-item {
    margin-bottom: 12px;
  }

  .ant-form-item-label {
    padding: 0px;
  }
`;

const EbzUpload = styled(Upload)`
  .ant-upload-select {
    width: 100%;
  }

  .ant-upload-list-item {
    box-shadow: 0px 2px 6px #0000001a;
    border: 0px !important;
  }
`;

const MetaWrapper = styled(Meta)`
  && {
    width: 100%;
    margin-top: 2%;
    border-top: 1px solid rgba(0, 0, 0, 0.15);
  }

  .ant-card-meta-description {
    font-size: 0.8rem;
    padding-left: 2%;
    padding-right: 2%;
  }
`;

const filtersArr = [
  {
    label: 'Status',
    attr: 'status',
    data: payoutStatus
  }
];

const searchArr = [
  {
    value: '_id',
    label: 'Report Name'
  },
  {
    value: 'invoice_name',
    label: 'Invoice Name'
  }
];

function PayoutReportsListPage() {
  // Page State
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [hasData, setHasData] = useState(false);
  const [data, setData] = useState({});
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
      showSizeChanger: false,
      total: 0
    }
  });
  const [viewMoreModal, setViewMoreModal] = useState(false);
  const [currentView, setCurrentView] = useState(null);
  const [disputeModalOpen, setDisputeModalOpen] = useState(false);
  const [disputeLoading, setDisputeLoading] = useState(false);
  const [kycModal, setKycModal] = useState(false);
  const [pendingInvoice, setPendingInvoice] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState();
  const [invoiceSummaryModal, setInvoiceSummaryModal] = useState(false);
  const [bulkInvoiceModal, setBulkInvoiceModal] = useState(false);
  const [bulkInvoiceLoading, setBulkInvoiceLoading] = useState(false);
  const [raiseInvoiceModal, setRaiseInvoiceModal] = useState(false);
  const [requestRaiseModal, setRequestRaiseModal] = useState(false);
  const [requestRaiseModalTitle, setRequestRaiseModalTitle] = useState('Request');
  const [disputeForm] = Form.useForm();
  const [raiseInvoiceForm] = Form.useForm();
  const [filtersObj, setFiltersObj] = useState({});
  const [tourGuideRun, setTourGuideRun] = useState(false);
  const [tourGuideSteps, setTourGuideSteps] = useState([]);
  const [tourStepIndex, setTourStepIndex] = useState(1);

  // const planType = useSelector((state) => state.user.plan.plan_type);
  const isPayoutReport = useSelector((state) => state.user.planPermissions.can_view_payout_report);
  const isInvoiceUpload = useSelector((state) => state.user.planPermissions.can_upload_invoice);

  const isDownloadPayoutReport = useSelector(
    (state) => state.user.planPermissions.can_download_transactions_payout_report
  );

  const planModal = useSelector((state) => state.user.planModal);
  const tourGuide = useSelector((state) => state.user.navigationTourGuidetails);

  const dispatch = useDispatch();
  const togglePlanModal = () => {
    dispatch(updatePlanModal(!planModal));
  };

  const handleViewMore = (e) => {
    setViewMoreModal(e);
    setCurrentView(null);
  };

  const handleDisputeModal = (e) => {
    disputeForm.resetFields();
    setDisputeModalOpen(e);
  };

  const handleRaiseInvoiceModal = (e) => {
    raiseInvoiceForm.resetFields();
    setRaiseInvoiceModal(e);
  };

  const handleKycModal = (e) => {
    setKycModal(e);
  };

  const handleRaiseRequestModal = (e, t) => {
    setRequestRaiseModal(e);
    setRequestRaiseModalTitle(`${t} request`);
  };

  const fetchPayoutReports = async (pagination, filters) => {
    setLoading(true);
    const response = await reportsAPI.payoutList({
      current_page: pagination.current,
      total_counts: pagination.total,
      ...filters
    });

    if (!response.success) {
      console.log('something went wrong');
      // Alert('something went wrong', 'Please contact support team for this', 'error');
      setHasData(false);
    }

    setData(response?.data ?? []);
    setLoading(false);
    setTableParams({
      ...tableParams,
      pagination: {
        ...pagination,
        total: response?.data.total_counts
      }
    });
  };

  const fetchBulkPendingInvoice = async () => {
    setBulkInvoiceLoading(true);
    const response = await reportsAPI.bulkInvoiceList({});

    if (!response.success) {
      console.log('something went wrong');
      setHasData(false);
    }
    setPendingInvoice(response?.data ?? []);
    setBulkInvoiceLoading(false);
  };
  const payoutRaiseDispute = async (payload) => {
    setLoading(true);
    setDisputeLoading(true);
    const response = await reportsAPI.payoutRaiseDispute(payload, {
      'content-type': 'multipart/form-data'
    });

    if (response.success) {
      setDisputeLoading(false);
      setDisputeModalOpen(false);
      setLoading(false);
      setViewMoreModal(false);
      fetchPayoutReports(tableParams.pagination, filtersObj);
    } else {
      setDisputeLoading(false);
      setLoading(false);
      setViewMoreModal(false);
      console.log('something went wrong');
      Alert(response.message, 'Please contact support team for this', 'error');
    }
  };

  const payoutAcceptInvoice = async (payload) => {
    setLoading(true);
    const response = await reportsAPI.bulkInvoiceSubmit(payload, {
      'content-type': 'multipart/form-data'
    });

    if (response.success) {
      handleRaiseRequestModal(true, 'Invoice');
      setLoading(false);
      setInvoiceSummaryModal(false);
      setViewMoreModal(false);
      fetchPayoutReports(tableParams.pagination, filtersObj);
    } else {
      setLoading(false);
      setViewMoreModal(false);
      console.log('something went wrong');
      Alert(response.message, 'Please contact support team for this', 'error');
    }
  };

  const kycVerify = async () => {
    message.info({
      content: 'Fetching Kyc verification link'
    });

    const response = await merchantAPI.partnerKycVerify();

    if (response.success) {
      window.open(response.data.redirection_url);
      message.info({
        content: 'You are being redirected to link'
      });
    } else {
      console.log('something went wrong');
      Alert('something went wrong', response?.data?.error?.message, 'error');
    }
  };

  const handleDownloadReport = async (Uniqueid, Uniquekey) => {
    const response = await reportsAPI.downloadReport({
      unique_id: Uniqueid,
      unique_key: Uniquekey
    });

    if (response.success) {
      window.open(response.data.url);
    } else {
      console.log('something went wrong');
      Alert('something went wrong', 'Please contact support team for this', 'error');
    }
    trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, {
      name: 'Payout Report Downloaded',
      'unique-key': Uniquekey,
      unique_id: Uniqueid
    });
  };
  //

  // functions
  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter
    });

    fetchPayoutReports(pagination, filtersObj);
  };

  const applyFiltersCallbackfunc = (a) => {
    setLoading(true);

    const updatePagination = { ...tableParams.pagination };
    updatePagination.current = 1;
    updatePagination.total = 0;

    const [searchParams, checkboxGroup] = a;
    const filters = {
      ...searchParams,
      ...checkboxGroup
    };

    setFiltersObj(filters);
    fetchPayoutReports(updatePagination, filters);
  };

  const clearFiltersCallBackfun = () => {
    setLoading(true);

    const updatePagination = { ...tableParams.pagination };
    updatePagination.current = 1;
    updatePagination.total = 0;

    fetchPayoutReports(updatePagination);
  };

  const submitRaiseDispute = (e) => {
    const file = e.upload_claim_proof ? e.upload_claim_proof[0].originFileObj : null;
    const formData = new FormData();
    formData.set('partner_payout_id', currentView?.format?._id);
    formData.set('amount', parseFloat(e.claim_amount));
    formData.set('remark', e.remarks);
    formData.set('partner_invoice', file);
    payoutRaiseDispute(formData);
  };

  const submitInvoiceAccept = (e) => {
    const file = e.upload_invoice ? e.upload_invoice[0].originFileObj : null;
    const formData = new FormData();
    formData.set('partner_payout_id', currentView?.format?._id);
    formData.set('amount', parseFloat(e.invoice_amount));
    formData.set('partner_invoice', file);
    formData.set('partner_invoice_number', e.invoice_number);
    payoutAcceptInvoice(formData);
  };

  const handleAcceptInvoice = (payoutReportId) => {
    if (currentView?.unformat.kyc_status === true) {
      setSelectedInvoice([payoutReportId]);
      setInvoiceSummaryModal(true);
    } else {
      handleKycModal(true);
    }
  };

  const handleFieldsChange = (e) => {
    if (
      e[0].name[0] === 'invoice_amount' &&
      e[0].value !== parseFloat(currentView.unformat.invoice_amount)
    ) {
      raiseInvoiceForm.setFields([
        {
          name: 'invoice_amount',
          errors: ["Payout doesn't match with record, Please raise dispute for this."]
        }
      ]);
    }
  };

  useEffect(() => {
    if (isPayoutReport) {
      fetchPayoutReports(tableParams.pagination);
    } else {
      navigate('/');
    }
  }, [isPayoutReport]);

  useEffect(() => {
    if (Object.keys(data).length !== 0) {
      setHasData(true);
    }
  }, [data]);
  //

  useEffect(() => {
    if (kycModal) {
      lottie.loadAnimation({
        container: document.querySelector('#kyc-icon'),
        animationData: searchJson,
        renderer: 'svg',
        loop: true,
        autoplay: true
      });
    }

    return () => {
      lottie.destroy();
    };
  }, [kycModal]);
  //

  const handleViewDetails = (e) => {
    handleViewMore(true);
    trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, { name: 'View Details' });
    const t = PAYOUT_REPORT_STATUS[e.status] ? (
      <Tag
        color={PAYOUT_REPORT_STATUS[e.status].bgColor}
        style={{
          padding: '2px 13px',
          color: PAYOUT_REPORT_STATUS[e.status].color,
          fontSize: '12px'
        }}
      >
        {PAYOUT_REPORT_STATUS[e.status].label}
      </Tag>
    ) : (
      <Tag color="#EBEBEB" style={{ padding: '2px 13px', color: '#7B7B7B', fontSize: '12px' }}>
        {e.status}
      </Tag>
    );
    const a = {
      format: {
        ...e,
        payout_start_date:
          e.payout_start_date === null
            ? 'Invalid Date'
            : dayjs(e.payout_start_date).format("DD MMM, 'YY"),
        payout_end_date:
          e.payout_end_date === null
            ? 'Invalid Date'
            : dayjs(e.payout_end_date).format("DD MMM, 'YY"),
        document_created_at:
          e.document_created_at === null
            ? 'Invalid Date'
            : dayjs(e.document_created_at).format("DD MMM, 'YY"),
        final_commission_amount: currencyFormat(e.final_commission_amount, true, true),
        dispute_amount: e?.dispute_amount && currencyFormat(e.dispute_amount, true, true),
        invoice_gst_amount:
          e?.invoice_gst_amount && currencyFormat(e.invoice_gst_amount, true, true),
        paid_amount: e?.paid_amount && currencyFormat(e.paid_amount, true, true),
        invoice_amount: e?.invoice_amount && currencyFormat(e.invoice_amount, true, true),
        tds_amount: e?.tds_amount && currencyFormat(e.tds_amount, true, true),
        invoice_status: e?.invoice_status,
        status: t,

        ...(e.dispute_expired_at !== undefined && {
          expired: dayjs(e.dispute_expired_at).isBefore(dayjs()),
          dispute_expired_at:
            e.dispute_expired_at === null
              ? 'Invalid Date'
              : dayjs(e.dispute_expired_at).format("DD MMM, 'YY")
        })
      },
      unformat: { ...e }
    };

    setCurrentView(a);
  };

  const handleInvoiceSummaryModal = () => {
    if (invoiceSummaryModal) setSelectedInvoice([]);
    setBulkInvoiceModal(false);
    setInvoiceSummaryModal(!invoiceSummaryModal);
  };
  const handleBulkInvoiceUpload = () => {
    if (!bulkInvoiceModal) fetchBulkPendingInvoice();
    setBulkInvoiceModal(!bulkInvoiceModal);
    if (invoiceSummaryModal) handleInvoiceSummaryModal();
    setSelectedInvoice([]);
  };

  const uploadProps = {
    maxCount: 1,
    listType: 'picture',
    // eslint-disable-next-line react/no-unstable-nested-components
    iconRender: () => {
      return <FilePdfOutlined />;
    },
    beforeUpload: (file) => {
      const isPDF = file.type === 'application/pdf';
      if (!isPDF) {
        message.error(`${file.name} is not a PDF file`);
      }
      // const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isLt2M) {
      //   message.error('Image must smaller than 2MB!');
      // }
      return isPDF || Upload.LIST_IGNORE;
    },
    customRequest: async (options) => {
      const uploadService = () => {
        return Promise.resolve();
      };
      const url = await uploadService();
      options.onProgress({ percent: 0 });
      options.onProgress({ percent: 100 });
      options.onSuccess();
    }
  };

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  const fetchAndUpdateNavigation = async (paramKey) => {
    const request = {
      update: paramKey
    };
    const response = await merchantAPI.fetchNavigationFlag(request);
    if (response.success) {
      dispatch(updateNavigationTourGuide(response?.data));
    } else {
      console.log('something went wrong');
    }
  };

  const handleJoyrideCallback = (callbackProps) => {
    const { status, index, type, action, size } = callbackProps;
    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      if ([ACTIONS.NEXT].includes(action)) {
        const nextIndex = index + 1;
        setTourStepIndex(nextIndex);
      } else {
        const prevIndex = index - 1;
        setTourStepIndex(prevIndex);
      }
      if (index === 1 && [ACTIONS.PREV].includes(action)) {
        setTourGuideRun(false);
        fetchAndUpdateNavigation('disable_payout_report_guide');
      }
    }

    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      // Need to set our running state to false, so we can restart if we click start again.
      setTourGuideRun(false);
    }
    const lastStepIndex = size - index;
    if ([ACTIONS.CLOSE].includes(action) || [EVENTS.TOUR_END].includes(type)) {
      if (lastStepIndex > 1) {
        setTourStepIndex(size - 1);
      } else {
        setTourGuideRun(false);
        fetchAndUpdateNavigation('disable_payout_report_guide');
      }
    }
  };

  useEffect(() => {
    if (
      tourGuide?.dashboard_guide?.tour_guide &&
      tourGuide?.dashboard_guide?.dashboard_modules?.disable_payout_report_guide &&
      data?.data
    ) {
      setTourGuideRun(!tourGuideRun);
      setTourGuideSteps(TOUR_PAYOUT_REPORT_CONTENT);
    }
  }, [tourGuide, data?.data]);

  return (
    <>
      <Joyride
        callback={handleJoyrideCallback}
        continuous
        run={tourGuideRun}
        steps={tourGuideSteps}
        scrollOffset={64}
        showSkipButton
        tooltipComponent={joyrideCustomTooltip}
        stepIndex={tourStepIndex}
      />
      <div
        style={{
          padding: '10px 24px'
        }}
      >
        <Space
          direction="horizontal"
          style={{
            display: 'flex',
            width: '100%',
            marginBottom: '10px',
            justifyContent: 'space-between'
          }}
        >
          <Space>
            {isPayoutReport ? (
              <Popover
                placement="bottomLeft"
                content={
                  <EbzFilterGroup
                    searchParams={searchArr}
                    filters={filtersArr}
                    apply={applyFiltersCallbackfunc}
                    clear={clearFiltersCallBackfun}
                  />
                }
                trigger="click"
                overlayStyle={{
                  width: '400px'
                }}
                overlayClassName="ebz-filters-popover"
              >
                <EbzButton size="large">
                  Search & Filter <DownOutlined />
                </EbzButton>
              </Popover>
            ) : (
              <Button type="primary" size="large" disabled>
                Search & Filter <DownOutlined />
              </Button>
            )}
          </Space>
          <Space>
            <Button
              type="primary"
              size="medium"
              onClick={() => {
                trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, {
                  name: 'Bulk Invoice Upload'
                });
                handleBulkInvoiceUpload();
              }}
              disabled={!isInvoiceUpload}
            >
              Bulk Invoice Upload
            </Button>
            <BulkInvoiceModal
              columns={getBulkInvoiceColumn(handleViewDetails)}
              invoiceData={pendingInvoice}
              toggleInvoiceSummary={handleInvoiceSummaryModal}
              setSelectedInvoice={setSelectedInvoice}
              invoiceSummaryModal={invoiceSummaryModal}
              selectedInvoice={selectedInvoice}
              bulkInvoiceModal={bulkInvoiceModal}
              payoutAcceptInvoice={payoutAcceptInvoice}
              width="100%"
              loading={bulkInvoiceLoading}
              toggleModal={handleBulkInvoiceUpload}
            />
          </Space>
        </Space>
        {isPayoutReport ? (
          <EbzTable
            columns={getPayoutReportColumn(handleViewDetails)}
            // eslint-disable-next-line no-underscore-dangle
            rowKey={(r) => `${r._id}_payout_report`}
            scroll={{
              x: 1000,
              y: 500
            }}
            dataSource={hasData ? data?.data : []}
            rowClassName={() => 'ebzCustomTable'}
            loading={loading}
            pagination={tableParams.pagination}
            onChange={handleTableChange}
            size="middle"
            className="payout-report-data"
          />
        ) : (
          <div
            style={{
              position: 'relative'
            }}
          >
            <img src={PayoutReportBlur} alt="CUstom Report Table" style={{ maxWidth: '100%' }} />
            <div
              style={{
                position: 'absolute',
                textAlign: 'center',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
              }}
            >
              <Typography.Title level={4}>
                Explore trends, search through & generate new payout reports from the dashboard on
                the Premium Plan.
              </Typography.Title>
              <Button type="primary" onClick={togglePlanModal}>
                View Plans
              </Button>
            </div>
          </div>
        )}
        <Drawer
          title={
            <CloseIcon
              style={{
                fontSize: '30px',
                color: 'var(--color-primary)',
                position: 'absolute',
                top: '30px',
                left: '-16px',
                cursor: 'pointer'
              }}
              onClick={() => handleViewMore(false)}
            />
          }
          placement="right"
          width={550}
          closable={false}
          open={viewMoreModal}
          rootClassName="payout-drawer"
        >
          <Row gutter={[20, 20]}>
            <Col span={24}>
              <Typography.Text style={{ fontSize: '22px', fontWeight: '500' }}>
                Payout Report Details
              </Typography.Text>
            </Col>
            <Col span={24}>
              <Space
                direction="horizontal"
                style={{ width: '100%', justifyContent: 'space-between' }}
              >
                <Typography.Text
                  copyable={{
                    icon: [
                      <CopyIcon style={{ color: 'var(--color-primary)' }} />,
                      <CheckOutlined style={{ color: 'var(--color-primary)' }} />
                    ],
                    onCopy: () => {
                      trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, {
                        name: 'Copy Payout ID'
                      });
                    }
                  }}
                >
                  {currentView?.format?._id}
                </Typography.Text>

                {/* <EbzButton size="large">Download</EbzButton> */}
                {/* <SelectWrapper
                suffixIcon={<CaretDownOutlined style={{ fontSize: '15px', color: '#2A2A2A' }} />}
                style={{
                  width: 150
                }}
                defaultValue={[
                  {
                    value: 'Downloads',
                    label: 'Downloads'
                  }
                ]}
                options={[
                  {
                    value: `MR@l${currentView?.unformat?.merchant_report_url}`,
                    label: 'Merchant Report'
                  },
                  {
                    value: `TR@l${currentView?.unformat?.transaction_report_url}`,
                    label: 'Transaction Report'
                  }
                ]}
                onChange={handleChange}
              /> */}
              </Space>
            </Col>
            <Col span={24}>
              <Descriptions column={1} bordered labelStyle={{ backgroundColor: '#FFFFFF' }}>
                <Descriptions.Item label="Report Name">
                  {currentView?.format?._id}
                </Descriptions.Item>
                {currentView?.unformat?.partner_invoice_no !== undefined &&
                  currentView?.unformat?.partner_invoice_no !== null && (
                    <Descriptions.Item label="Invoice Number">
                      {currentView?.unformat?.partner_invoice_no}
                    </Descriptions.Item>
                  )}
                <Descriptions.Item label="Easebuzz GST">27AAVCS2699M1Z5</Descriptions.Item>
                <Descriptions.Item label="Report Start Date">
                  {currentView?.format?.payout_start_date}
                </Descriptions.Item>
                <Descriptions.Item label="Report End Date">
                  {currentView?.format?.payout_end_date}
                </Descriptions.Item>
                <Descriptions.Item label="Generation Date">
                  {currentView?.format?.document_created_at}
                </Descriptions.Item>
                {currentView?.format?.dispute_expired_at && (
                  <Descriptions.Item label="Expiry Date">
                    {currentView?.format?.dispute_expired_at}
                  </Descriptions.Item>
                )}
                <Descriptions.Item label="Commission Amount">
                  <Typography.Text style={{ wordSpacing: '12px' }}>
                    {currentView?.format?.final_commission_amount}
                  </Typography.Text>
                </Descriptions.Item>
                {currentView?.unformat?.dispute_amount !== undefined &&
                  currentView?.unformat?.dispute_amount !== null &&
                  currentView?.unformat?.dispute_amount > 0 && (
                    <Descriptions.Item label="Dispute Amount">
                      {currentView?.format?.dispute_amount}
                    </Descriptions.Item>
                  )}
                {currentView?.format?.invoice_gst_amount !== undefined && (
                  <Descriptions.Item label="GST Amount" padding="20px">
                    {currentView?.unformat?.status === 'DISPUTED' ? (
                      '-'
                    ) : (
                      <Typography.Text style={{ wordSpacing: '12px' }}>
                        {currentView?.format?.invoice_gst_amount}
                      </Typography.Text>
                    )}

                    <Tag
                      color={GST_STATUS[currentView?.unformat?.gst_status]?.bgColor}
                      style={{
                        padding: '2px 13px',
                        color: GST_STATUS[currentView?.unformat?.gst_status]?.color,
                        fontSize: '12px',
                        marginLeft: '10px'
                      }}
                    >
                      {GST_STATUS[currentView?.unformat?.gst_status]?.label}
                    </Tag>
                  </Descriptions.Item>
                )}
                {currentView?.format?.invoice_amount !== undefined && (
                  <Descriptions.Item label="Invoice Amount">
                    {currentView?.unformat?.status === 'DISPUTED' ? (
                      '-'
                    ) : (
                      <Typography.Text style={{ wordSpacing: '12px' }}>
                        {currentView?.format?.invoice_amount}
                      </Typography.Text>
                    )}
                  </Descriptions.Item>
                )}
                {currentView?.format?.paid_amount !== undefined && (
                  <Descriptions.Item label="Paid Amount">
                    <Typography.Text style={{ wordSpacing: '12px' }}>
                      {currentView?.format?.paid_amount}
                    </Typography.Text>
                  </Descriptions.Item>
                )}
                {currentView?.format?.tds_amount !== undefined &&
                  currentView?.format?.tds_amount !== null && (
                    <Descriptions.Item label="TDS Amount">
                      {currentView?.format?.tds_amount}
                    </Descriptions.Item>
                  )}
                {currentView?.unformat?.payout_utr !== undefined &&
                  currentView?.unformat?.payout_utr !== null && (
                    <Descriptions.Item label="Payout UTR">
                      {currentView?.unformat?.payout_utr}
                    </Descriptions.Item>
                  )}
                {currentView?.unformat?.gst_utr !== undefined &&
                  currentView?.unformat?.gst_utr !== null && (
                    <Descriptions.Item label="GST UTR">
                      {currentView?.unformat?.gst_utr}
                    </Descriptions.Item>
                  )}

                {isDownloadPayoutReport && (
                  <Descriptions.Item label="Downloads">
                    <EbzButton
                      size="middle"
                      onClick={() => {
                        handleDownloadReport(
                          currentView?.format?._id,
                          currentView?.unformat?.merchant_report_url
                        );
                      }}
                    >
                      <span style={{ textDecoration: 'underline' }}>Commission Report</span>
                    </EbzButton>
                    <br />
                    {currentView?.unformat?.transaction_report_url !== null && (
                      <>
                        <EbzButton
                          size="middle"
                          onClick={() => {
                            handleDownloadReport(
                              currentView?.format?._id,
                              currentView?.unformat?.transaction_report_url
                            );
                          }}
                          style={{ marginTop: '15px' }}
                        >
                          <span style={{ textDecoration: 'underline' }}>
                            Referralwise Performance Report
                          </span>
                        </EbzButton>
                        <br />
                        <EbzButton
                          size="middle"
                          onClick={() => {
                            handleDownloadReport(
                              currentView?.format?._id,
                              currentView?.unformat?.consolidated_transaction_report_url
                            );
                          }}
                          style={{ marginTop: '15px' }}
                        >
                          <span style={{ textDecoration: 'underline' }}>
                            Referral Consolidated Performance Report
                          </span>
                        </EbzButton>
                        <br />
                        {currentView?.unformat?.payment_mode_wise_report_url !== null && (
                          <EbzButton
                            size="middle"
                            onClick={() => {
                              handleDownloadReport(
                                currentView?.format?._id,
                                currentView?.unformat?.payment_mode_wise_report_url
                              );
                            }}
                            style={{ marginTop: '15px' }}
                          >
                            <span style={{ textDecoration: 'underline' }}>
                              Payment Mode Wise Report
                            </span>
                          </EbzButton>
                        )}
                      </>
                    )}
                  </Descriptions.Item>
                )}

                <Descriptions.Item label="Status">{currentView?.format?.status}</Descriptions.Item>
                {currentView?.unformat?.hold_reason !== undefined &&
                  currentView?.unformat?.hold_reason !== null &&
                  currentView?.unformat?.invoice_status === PARTNER_INVOICE_ON_HOLD && (
                    <Descriptions.Item label="Remarks">
                      {INVOICE_ON_HOLD_REASON_DICT[currentView?.unformat?.hold_reason]
                        ? INVOICE_ON_HOLD_REASON_DICT[currentView?.unformat?.hold_reason]
                        : currentView?.unformat?.hold_reason}
                    </Descriptions.Item>
                  )}
              </Descriptions>
            </Col>
            <Col span={24}>
              <Space size="middle">
                {currentView?.unformat?.invoice_status === PARTNER_INVOICE_PENDING && (
                  <EbzButton
                    size="large"
                    onClick={() => {
                      handleAcceptInvoice(currentView?.format?._id);
                      trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, {
                        name: 'Accept Payout Invoice'
                      });
                    }}
                    disabled={!isInvoiceUpload}
                  >
                    Accept
                  </EbzButton>
                )}
                {currentView?.unformat?.invoice_status === PARTNER_INVOICE_ON_HOLD && (
                  <EbzButton
                    size="large"
                    onClick={() => {
                      handleAcceptInvoice(currentView?.format?._id);
                      trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, {
                        name: 'Re-Upload Payout Invoice'
                      });
                    }}
                  >
                    Re-Upload
                  </EbzButton>
                )}
              </Space>
            </Col>
          </Row>
        </Drawer>
        {/* Raise Dispute Modal */}
        <Modal
          title={
            <Typography.Text style={{ fontSize: '18px', fontWeight: '500' }}>
              Raise a Dispute
            </Typography.Text>
          }
          centered
          open={disputeModalOpen}
          // open
          closable={false}
          onCancel={() => handleDisputeModal(false)}
          footer={[
            <Space size="small" style={{ marginTop: '35px' }}>
              {disputeLoading ? (
                <Button disabled>Cancel</Button>
              ) : (
                <EbzButton onClick={() => handleDisputeModal(false)}>Cancel</EbzButton>
              )}
              <Button
                form="dispute-form"
                key="submit"
                htmlType="submit"
                type="primary"
                loading={disputeLoading}
              >
                {disputeLoading ? 'Submitting...' : 'Submit'}
              </Button>
            </Space>
          ]}
        >
          <FormWrapper
            style={{ marginTop: '25px' }}
            form={disputeForm}
            name="dispute-form"
            layout="vertical"
            onFinish={submitRaiseDispute}
            size="large"
            initialValues={{
              calculated_amount: currentView?.unformat?.final_commission_amount,
              fileList: []
            }}
          >
            <Row gutter={[15, 0]}>
              <Col span={24}>
                <Form.Item label="Calculated Amount" name="calculated_amount">
                  <EbzInputNumber
                    prefix="₹"
                    disabled
                    controls={false}
                    style={{ width: '100%' }}
                    formatter={(v) => {
                      if (v !== '') return currencyFormat(v, false, false);
                      return v;
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="claim_amount"
                  label={
                    <>
                      <span>Claim Amount</span>
                      <span className="required-mark" />
                    </>
                  }
                  rules={[
                    {
                      required: true,
                      message: 'Please Enter Claim Amount'
                    }
                  ]}
                >
                  <EbzInputNumber
                    prefix="₹"
                    controls={false}
                    style={{ width: '100%' }}
                    formatter={(v) => {
                      if (v !== '') return currencyFormat(v, false, false);
                      return v;
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="remarks"
                  label={
                    <>
                      <span>Remarks</span>
                      <span className="required-mark" />
                    </>
                  }
                  rules={[
                    {
                      required: true,
                      message: 'Please Enter remarks'
                    },
                    {
                      message:
                        'Please enter a Remarks. (Only alpha-numeric, spaces and dashes allowed)',
                      pattern: '^[a-zA-Z0-9_ -]+[w-]*$'
                    }
                  ]}
                >
                  <Input.TextArea
                    autoSize={{
                      minRows: 3,
                      maxRows: 5
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label={
                    <>
                      Upload Claim Proof
                      <Tooltip title="Uploaded claim proof will not be honoured">
                        <InfoCircleOutlined style={{ color: '#A0A0A0', marginLeft: '5px' }} />
                      </Tooltip>
                    </>
                  }
                  name="upload_claim_proof"
                  valuePropName="fileList"
                  getValueFromEvent={normFile}
                >
                  <EbzUpload {...uploadProps}>
                    <Button
                      icon={
                        <ExportIcon
                          style={{
                            color: 'var(--color-primary)',
                            fontSize: '16px'
                          }}
                        />
                      }
                    >
                      Upload
                    </Button>
                  </EbzUpload>
                </Form.Item>
              </Col>
              <Col span={24}>
                <MetaWrapper
                  description="* Dispute to the invoices is without prejudice to the rights
                of the Company under the Agreement and subject to further
                review and verification."
                />
              </Col>
            </Row>
          </FormWrapper>
        </Modal>
        {/* Raise Invoice modal */}
        {/* <Modal
        title={
          <Typography.Text style={{ fontSize: '18px', fontWeight: '500' }}>
            Accepted! Raise an Invoice Now
          </Typography.Text>
        }
        centered
        open={raiseInvoiceModal}
        // open
        closable={false}
        onCancel={() => handleRaiseInvoiceModal(false)}
        footer={[
          <Space size="small" style={{ marginTop: '35px' }}>
            {raiseInvoiceLoading ? (
              <Button disabled>Cancel</Button>
            ) : (
              <EbzButton onClick={() => handleRaiseInvoiceModal(false)}>Cancel</EbzButton>
            )}
            <Button
              form="raise-invoice-form"
              key="submit"
              htmlType="submit"
              type="primary"
              loading={raiseInvoiceLoading}
            >
              {raiseInvoiceLoading ? 'Raising Invoice' : 'Raise Invoice'}
            </Button>
          </Space>
        ]}
      >
        <FormWrapper
          style={{ marginTop: '25px' }}
          form={raiseInvoiceForm}
          name="raise-invoice-form"
          layout="vertical"
          onFinish={submitInvoiceAccept}
          size="large"
          initialValues={{
            invoice_amount: currentView?.unformat?.invoice_amount
          }}
          onFieldsChange={handleFieldsChange}
        >
          <Row gutter={[15, 0]}>
            <Col span={24}>
              <Form.Item
                name="invoice_number"
                label={
                  <>
                    <span>Invoice Number</span>
                    <span className="required-mark" />
                  </>
                }
                rules={[
                  {
                    required: true,
                    message: 'Please Enter Invoice Number'
                  }
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="invoice_amount"
                label={
                  <>
                    <span>Total Invoice Amount</span>
                    <span className="required-mark" />
                  </>
                }
                rules={[
                  {
                    required: true,
                    message: 'Please Enter Total Invoice Amount'
                  }
                ]}
              >
                <EbzInputNumber
                  prefix="₹"
                  controls={false}
                  style={{ width: '100%' }}
                  formatter={(v) => {
                    if (v !== '') return currencyFormat(v, false, false);
                    return v;
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label={
                  <>
                    <span>Upload Invoice (Kindly mention the HSN/SAC code in the invoice)</span>
                    <span className="required-mark" />
                  </>
                }
                name="upload_invoice"
                valuePropName="fileList"
                getValueFromEvent={normFile}
                rules={[
                  {
                    required: true,
                    message: 'Please upload your invoice pdf'
                  }
                ]}
              >
                <EbzUpload {...uploadProps}>
                  <Button
                    icon={
                      <ExportIcon
                        style={{
                          color: var(--color-primary),
                          fontSize: '16px'
                        }}
                      />
                    }
                  >
                    Upload
                  </Button>
                </EbzUpload>
              </Form.Item>
            </Col>
            <Col span={24}>
              <MetaWrapper
                description="* Uploaded invoice is subject to internal verification and further
                review and shall be processed as per the Partner’s Terms of Use."
              />
            </Col>
          </Row>
        </FormWrapper>
      </Modal> */}
        {/* Kyc verification modal */}
        <Modal
          centered
          open={kycModal}
          closable={false}
          onCancel={() => handleKycModal(false)}
          footer={null}
          width={700}
        >
          <Row gutter={[10, 10]} style={{ width: '100%', padding: '20px 0px' }}>
            <Col span={9} style={{ display: 'flex', justifyContent: 'center' }}>
              <div id="kyc-icon" style={{ width: '100%', height: '200px' }} />
            </Col>
            <Col span={15} style={{ display: 'flex', justifyContent: 'center' }}>
              <Space direction="vertical" size="large">
                <Typography.Text style={{ fontSize: '20px', fontWeight: '500' }}>
                  Oh, no! Your KYC verification is pending
                </Typography.Text>
                <Typography.Text style={{ fontSize: '15px' }}>
                  Your KYC is not approved. Please make sure your KYC is submitted and approved,
                  before raising an invoice.
                </Typography.Text>
                <Space size="middle" style={{ width: '100%' }}>
                  <Button
                    type="primary"
                    size="large"
                    onClick={() => {
                      trackingService.trackEvent(EVENT_NAME, { name: 'Complete Kyc' });
                      kycVerify();
                      handleKycModal(false);
                    }}
                  >
                    Complete KYC
                  </Button>
                  <EbzButton
                    size="large"
                    onClick={() => {
                      handleKycModal(false);
                      handleViewMore(false);
                    }}
                  >
                    I&apos;ll do it Later
                  </EbzButton>
                </Space>
              </Space>
            </Col>
          </Row>
        </Modal>
        {/* Request Raised Alert */}
        <Modal
          title={
            <Typography.Text
              style={{
                fontSize: '20px',
                fontWeight: '500',
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                padding: '10px',
                borderBottom: '1px solid #A0A0A0'
              }}
            >
              {requestRaiseModalTitle} registered successfully!
            </Typography.Text>
          }
          centered
          open={requestRaiseModal}
          closable
          onCancel={() => handleRaiseRequestModal(false)}
          footer={[
            <Space style={{ width: '100%', justifyContent: 'center' }}>
              <Button type="primary" onClick={() => handleRaiseRequestModal(false)}>
                Acknowledge
              </Button>
            </Space>
          ]}
        >
          <Space
            style={{
              padding: '25px',
              textAlign: 'center'
            }}
          >
            <Typography.Text
              style={{
                fontSize: '16px',
                width: '100%'
              }}
            >
              The requested report is being generated. You can download the requested report from
              the Reports dashboard once generated.
            </Typography.Text>
          </Space>
        </Modal>
      </div>
    </>
  );
}

export default PayoutReportsListPage;
